
@if (point()) {
  <article 
    class="suggested-points__point"
    (click)="handleClick(point())"
  >
    <app-header [indexCard]="indexCard()" [point]="point()" />
    

    <app-main [point]="point()" />
    
    <app-footer />
  </article>
}